import {
	Outlet,
	createFileRoute,
	redirect,
	useLocation,
} from "@tanstack/react-router";
import { Navbar } from "~/components/navbar";
import { ChatWidgetWrapper } from "~/components/practice/chat-widget-wrapper";
import type { Role } from "~/lib/server/auth";
import { getAuthSession } from "~/lib/server/functions/auth";

const ALLOWED_ROLES: Role[] = ["admin", "beta-tester"];

export const Route = createFileRoute("/app")({
	beforeLoad: async ({ location }) => {
		const { isAuthenticated, user } = await getAuthSession();
		if (!isAuthenticated) throw redirect({ to: "/" });

		if (!ALLOWED_ROLES.includes(user.role)) {
			throw redirect({ to: "/maintenance" });
		}

		// if the path is only "/app" redirect to "/app/chat" by default
		if (location.pathname === "/app") {
			throw redirect({ to: "/app/chat" });
		}
	},
	component: AppLayout,
});

function AppLayout() {
	const location = useLocation();
	const isChatPage = location.pathname.startsWith("/app/chat");

	return (
		<div className="flex flex-col h-full">
			<div className="-z-10 fixed inset-0 bg-gradient-to-t from-pink-50 to-white" />
			<Navbar />
			<div className="flex-1 pt-16 lg:pt-0 lg:pl-72 min-h-0">
				<Outlet />
			</div>
			{!isChatPage && <ChatWidgetWrapper />}
		</div>
	);
}
